export default {
  en: "Анг | Англи",
  mn: "Мн | Монгол",
  
  all: "Бүгд",
  attention: "Анхаар",
  amount: "Дүн",
  account: "Данс",
  account_name: "Дансны нэр",
  account_number: "Дансны дугаар.",
  account_opening: "Данс нээх",
  account_closing: "Данс хаах",
  account_balance: "Дансны үлдэгдэл",
  attachment_info: "Хавсралтын мэдээлэл",
  approved: "Зөшөөрөгдсөн",
  account_id: "Дансны ID",
  accumulate_turnover: "Эргэлтийг хуримтлуулах",

  bank_details: "Банкны мэдээлэл",
  bank: "Банк",
  bank_name: "Банкны нэр",
  bet_history: "Бооцооны түүх",
  bet_count: "Бооцооны тоо",
  back_to_top: "Дээш буцах",
  bet_id: "Бооцооны ID",
  bet_time: "Бооцооны цаг",
  bonus: "Бонус",
  balance: "Үлдэгдэл",

  casino: "Казино",
  copyright: "Зохиогчийн эрх © 2024 {brand}. | Бүх эрх хуулиар хамгаалагдсан",
  contact_livechat: "{brand} Livechat-тай холбогдох",
  choose_file: "Файл сонгох",
  cancel: "Цуцлах",
  commission: "Хувь авах",
  category: "Ангилал",
  contact_phone: "Холбоо барих утас",
  contact_email: "Холбоо барих имэйл",
  contact_no_phone: "Холбоо барих (утас)",
  contact_no_viber: "Холбоо барих (Viber)",
  copy: "Хуулах",
  criteria: "шалгуур",
  coming_soon: "Удахгүй",

  date: "Огноо",
  download: "Татаж авах",
  deposit: "Депосит",
  deposit_channel: "Депосит суваг",
  deposit_methods: "Депосит аргууд",
  deposit_options: {
    online_banking: "Онлайн банк",
    atm_transfer: "ATM шилжүүлэг",
    cash_deposit: "Бэлэн мөнгөний хадагламж"
  },

  event: "Үйл явдал",
  eta: "Болон Бусад",

  full_name: "Бүтэн нэр",
  failed: "Амжилтгүй",
  fish: "Загас барих",
  favorite: "Дуртай",
  follow_us: "Биднийг дага",
  footermenu: {
    about_us: "Бидний тухай",
    privacy_policy: "Нууцлалын бодлого",
    responsible_gaming: "Тоглоомын Хариуцлага",
    banking: "Банк",
    faqs: "Түгээмэл асуултууд"
  },
  forgot_password: "Нууц үгээ мартсан",

  game_name: "Тоглоомын нэр",

  hot: "Халуун",

  login: "Нэвтрэх",
  lottery: "Сугалаа",
  lost: "Алдагдсан",
  last_4digits_contact: "Харилцах утасны сүүлийн 4 орон",

  mission: "Эрхэм зорилго",  
  minimum_amount: "Хамгийн бага хэмжээ",
  maximum_amount: "Хамгийн их хэмжээ",
  min_deposit: "Хамгийн бага хадгаламж",

  no_record: "Бичлэг олдсонгүй",

  odds: "Магадлал",
  others: "Бусад",

  password: "Нууц үг",
  password_current: "Одоогын Нууц Үг",
  password_new: "Шинэ нууц үг",
  password_confirm: "Нууц үгээ баталгаажуулах",
  password_change: "Нууц үг солих",
  poker: "Покер",
  promo: "Сурталчилгаа | Урамшуулал",
  provider: "Үйлчилгээ үзүүлэгч",
  payment_method: "Төлбөрийн нөхцөл",
  pending: "Хүлээгдэж байна",

  qrcode: "QRCode",

  rebate_amount: "Хөнгөлөлтийн дүн",
  rebate_details: "Хөнгөлөлтийн дэлгэрэнгүй мэдээлэл",
  rebate_balance: "Хөнгөлөлтийн үлдэгдэл",
  rebate: "Хөнгөлөлт",
  read_more: "Цааш унших",
  receipt: "Баримт бичиг",
  refno: "Ref, Дугаар",
  request_type: "Хүсэлтийн төрөл",
  remark: "Тайлбар",
  register: "Бүртгүүлэх",
  registration: "Бүртгэл",
  request_tac: "TAC хүсэлт",
  rollover: "Өнхрөх",
  
  slot: "Слот",
  sports: "Спорт",
  search_game: "Тоглоом хайх",
  statement: "Мэдэгдэл",
  submit: "Илгээх",
  success: "Амжилт",
  save: "Хадгалах",
  settlement: "Суурин газар",
  status: "Статус",
  stake: "Гадас",
  soccer: "Хөл бөмбөг",

  target_amount: "Зорилтот хэмжээ",
  transfer_type: "Шилжүүлгийн төрөл",
  transfer_history: "Шилжүүлгийн түүх",
  tac_code: "TAC код",
  transfer: "Шилжүүлэх",
  turnover: "Эргэлт",
  transaction_history: "Гүйлгээний түүх",
  tournament: "Тэмцээн",
  tooltips: {
    deposit_amount: "Дүнгээ оруулна уу (Хамгийн бага {minbet})",
    deposit_min: "* Депосит доод хэмжээг оруулна уу",
    select_promotion: "Урамшуулал сонгоно уу",
    file_upload: "Файлын хэмжээ 1 mb-аас хэтрэхгүй бөгөөд png, jpg эсвэл jpeg форматтай байх ёстой.",
    unsupported_format: "Дэмжигдээгүй файлын төрөл. Хүчинтэй файл сонгоно уу.",
    withdraw_amount: "Хэмжээ оруулна уу (МХамгийн багаин {min} | Хамгийн их {max})",
    max_withdraw_count: "Зөвхөн гишүүн өдөрт татан авалтын{count} тасалбар {ууд} илгээх боломжтой.,",
    rebate_amount: "Хэмжээ оруулна уу (МХамгийн багаин {min} | Хамгийн их {max})",
    bank_empty_info: "Банкны талаарх мэдээллийг манай харилцагчийн үйлчилгээнээс авна уу.",
    copy_qrcode: "QR кодын url-г санах ой руу хуулсан",
    last_4digits_contact: "Харилцах утасныхаа сүүлийн 4 оронтой тоог оруулна уу.",
    tac_livechat: "Хэрэв та TAC кодоо хүлээн авч чадаагүй хэвээр байвал манай оператортой холбогдож нэмэлт тусламж авна уу.",
    announcement: "UBWIN-д тавтай морилно уу. Хурдан мөнгө байршуулах, хурдан төлбөр хийх, хамгийн их итгэлийг UBWIN-д мэдрүүлж, том ялалтаар дүүрэн хосгүй тоглоомын туршлагыг мэдрээрэй."
  },
  transfer_amount: "Шилжүүлгийн дүн",

  username: "Хэрэглэгчийн нэр",

  valid_turnover: "Хүчин төгөлдөр эргэлт",

  withdraw: "Татаж авах",
  winlose: "Ялалт/хожигдол",
  win: "Ялах",
  welcome: "Тавтай морил"
};
